<h1 mat-dialog-title>{{data.title | translate}}</h1>
<div mat-dialog-content>
  <p style="text-align: center;" [innerHtml]="data.message | translate"></p>
  <app-loader></app-loader>
</div>
